import React from "react";

/**
 * Custom error class to throw an error when the context is used outside its provider
 *
 * @example
 * const context = useContext(AppContext);
 *
 * if(!context) {
 *    throw new ContextUsedOutsideProviderError(AppContext)
 * }
 */
export class ContextUsedOutsideProviderError extends Error {
  constructor(context: React.Context<any>) {
    super(`${context.displayName || "Context"} is being used outside of its Provider`);
  }
}
